import React from 'react';

import classNames from 'classnames';

import { Stack, Text, Columns, Column, Box } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';

import { SCHEDULE_DURATION } from '../../../../../lib/rentvsbuy-constants';
import { ChartData } from '../../../types';

// Styles
import styles from './results-tooltip.module.less';

export type ResultsTooltipProps = {
  chartData: ChartData;
  data: any;
  yRange: number;
};

const calculateTooltipPosition = (x, y, yRange) => {
  const element = document.getElementById('chartWrapper');
  // in case component rendered server side - don't have access to the DOM.
  if (!element) {
    return null;
  }

  // get the dimensions of the graph container.
  const rect = element.getBoundingClientRect();
  const width = rect.width;
  const height = rect.height;
  const leftLimit = 55;
  const topLimit = 55;

  let left = Math.round((((width / SCHEDULE_DURATION) * x) / width) * 100);
  let top = Math.round((((height / yRange) * y) / height) * 100);

  if (left > leftLimit) {
    left = leftLimit;
  }
  if (top > topLimit) {
    top = topLimit;
  }

  return { top, left };
};

const ResultsTooltip = ({
  chartData,
  yRange,
  data,
}: ResultsTooltipProps): JSX.Element => {
  const position = calculateTooltipPosition(chartData.x, chartData.y, yRange);
  if (!position) {
    return null;
  }

  const year = data[0].x;
  const rent = data[0].y;
  const buy = data[1].y;

  return (
    <Box
      className={styles.tooltipFlyout}
      style={{ top: `${position.top}%`, left: `${position.left}%` }}
    >
      <Stack>
        <Text>Year {year}</Text>
        <Columns spacing="0" alignY="top">
          <Column width="2">
            <Box
              component="div"
              className={classNames(styles.circle, styles.yellowCircle)}
            />
          </Column>
          <Column width="4">
            <Text light>Rent</Text>
          </Column>
          <Column width="6">
            <Text light>{num.formatCurrency(rent)}</Text>
          </Column>
        </Columns>
        <Columns spacing="0" alignY="top">
          <Column width="2">
            <Box
              component="div"
              className={classNames(styles.circle, styles.blueCircle)}
            />
          </Column>
          <Column width="4">
            <Text light>Buy</Text>
          </Column>
          <Column width="6">
            <Text light>{num.formatCurrency(buy)}</Text>
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
};

export default ResultsTooltip;
